import { render, staticRenderFns } from "./OverlayStatus.vue?vue&type=template&id=0f877684&"
import script from "./OverlayStatus.vue?vue&type=script&lang=js&"
export * from "./OverlayStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports